import {useContext} from 'react'
import {ProductReportContext} from '../../context'
import {DynamicTable} from '../../../../components/DynamicTable'
import {parseProductReportRow} from '../../parsings'
import ProductReportTableRow from './ProductReportTableRow'

const ProductReportTable = () => {
  const {reportData, isLoading, filters, pagination, onPageChange, onSortingChange} =
    useContext(ProductReportContext)

  const sortableColumns = [
    {
      key: 'child_data',
      label: '',
      isSorted: false,
      headerStyle: 'min-w-50px w-50px',
    },
    {
      key: 'parent_sku',
      label: 'SKU',
      isSorted: true,
      headerStyle: 'min-w-175px w-175px',
    },
    {
      key: 'product_title',
      label: 'Product Name',
      isSorted: true,
      headerStyle: 'min-w-600px w-600px',
    },
    {
      key: 'cost',
      label: 'Cost',
      isSorted: true,
      headerStyle: 'min-w-120px w-120px',
    },
    {
      key: 'purchaser_name',
      label: 'Purchaser Name',
      isSorted: true,
      headerStyle: 'min-w-175px w-175px',
    },
  ]

  return (
    <DynamicTable
      data={reportData}
      sortableColumns={sortableColumns}
      loading={isLoading}
      TableRow={ProductReportTableRow}
      noDataMessage='No products found'
      filters={filters}
      tableClass='table-row-bordered table-row-gray-300 align-middle gs-0 gy-3'
      pagination={pagination}
      onPageChange={onPageChange}
      onSortingChange={onSortingChange}
      rowParsingFunction={parseProductReportRow}
    />
  )
}

export default ProductReportTable
